import * as React from 'react'

import { DatePicker, Descriptions, Form, Input } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import UnitSelect from '../../UnitSelect'
import { invoiceRefExists } from '../api'
import { RuleObject } from 'antd/lib/form'
import { either } from 'fp-ts'

type Props = {
  invalidUnit?: boolean
  org?: string
}

const DividedForm = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;

  & .ant-picker {
    display: block;
  }
`

export default ({ invalidUnit, org }: Props) => {
  const intl = useIntl()
  const [ref, setRef] = React.useState('')

  const checkReference = async (_: RuleObject, v: string) => {
    if (either.isRight(await invoiceRefExists(org ?? '', v)())) {
      throw 'exists'
    }
  }

  return (
    <DividedForm>
      <div>
        <Descriptions.Item>
          <FormattedMessage id="invoiceRef" />
        </Descriptions.Item>
        <Form.Item
          style={{ marginTop: '10px' }}
          name="reference"
          rules={[
            {
              required: true,
              message: <FormattedMessage id="required" />,
            },
            {
              validator: checkReference,
              message: <FormattedMessage id="refAlreadyUsed" />,
            },
          ]}
        >
          <Input
            disabled={org === ''}
            value={ref}
            placeholder={
              org === ''
                ? 'Please insert a company name'
                : intl.formatMessage({ id: 'invoiceRef' })
            }
            onChange={e => {
              setRef(e.target.value)
            }}
          />
        </Form.Item>
        <Descriptions.Item>
          <FormattedMessage id="dueDate" />
        </Descriptions.Item>
        <Form.Item
          style={{ marginTop: '10px' }}
          name="dueAt"
          rules={[
            {
              required: true,
              message: <FormattedMessage id="required" />,
            },
          ]}
        >
          <DatePicker />
        </Form.Item>
      </div>
      <div>
        <Descriptions.Item>
          <FormattedMessage id="unit" />
        </Descriptions.Item>
        <Form.Item
          style={{ marginTop: '10px' }}
          name="unitID"
          rules={[
            {
              required: true,
              message: <FormattedMessage id="unitRequired" />,
            },
            {
              validator: () =>
                invalidUnit
                  ? Promise.reject('invalid unit')
                  : Promise.resolve(),
              message: <FormattedMessage id="invalidUnit" />,
            },
          ]}
        >
          <UnitSelect />
        </Form.Item>
        <Descriptions.Item>
          <FormattedMessage id="invoiceDate" />
        </Descriptions.Item>
        <Form.Item
          style={{ marginTop: '10px' }}
          name="createdAt"
          rules={[
            {
              required: true,
              message: <FormattedMessage id="required" />,
            },
          ]}
        >
          <DatePicker />
        </Form.Item>
      </div>
    </DividedForm>
  )
}
